export default {
  methods: {
    pointerClick(location) {
      let googleLink
      try {
        let origin = this.info.geoInfo.parsed_address.formatted_address
        let dest = location.name
        let destId = location.place_id
        googleLink = `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${dest}&destination_place_id=${destId}&travelmode=walking`
      } catch {
        let pointStr = location.geometry.location.lat + ',' + location.geometry.location.lng
        googleLink = `https://www.google.com/maps/search/?api=1&query=${pointStr}`
      }
      window.open(googleLink)
    }
  }
}
